// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import {
    ExcludeFromNavigation,
    ExcludeFromSignInRequired,
    HideFooter,
    HideFromSearchEngines,
    HideFromSiteSearch,
    HideHeader,
    HorizontalRule,
    MetaDescription,
    MetaKeywords,
    OpenGraphImage,
    OpenGraphTitle,
    OpenGraphUrl,
    StructuredPageData,
} from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import MobiusPage from "@insite/mobius/Page";
import { useUserNotificationPreferencesContext } from "@store/Framework/Components/UserNotificationPreferencesContext/UserNotificationPreferencesContext";
import UserNotificationPreferencesContextProvider from "@store/Framework/Components/UserNotificationPreferencesContext/UserNotificationPreferencesContextProvider";
import { getUserNotificationPreferences } from "@store/Framework/Services/UserProfileService";
import useQueryString from "@toolkit/Framework/Common/Hooks/useQueryString";
import React, { useEffect } from "react";

const NotificationPreferencesPage: React.FunctionComponent<PageProps> = ({ id }) => {
    return (
        <MobiusPage>
            <UserNotificationPreferencesContextProvider>
                <Zone contentId={id} zoneName="Content" />
            </UserNotificationPreferencesContextProvider>
        </MobiusPage>
    );
};

const pageModule: PageModule = {
    component: NotificationPreferencesPage,
    definition: {
        hasEditableTitle: true,
        hasEditableUrlSegment: true,
        pageType: "System",
        fieldDefinitions: [
            MetaKeywords,
            MetaDescription,
            OpenGraphTitle,
            OpenGraphUrl,
            OpenGraphImage,
            StructuredPageData,
            {
                ...HorizontalRule,
                sortOrder: 199,
            },
            HideHeader,
            HideFooter,
            HideFromSearchEngines,
            HideFromSiteSearch,
            ExcludeFromNavigation,
            ExcludeFromSignInRequired,
        ],
    },
};

export default pageModule;
